<template>
  <div>
    <HeaderSub/>
    <div class="login-wrap">
		<h2>麒麟软件账号注册</h2>
		<div class="register-tips">已有账号，<router-link class="bluecolor" to="/login">点击登录</router-link></div>
		<ul class="login-ul">
			<li>
				<input type="text" placeholder="邮件地址"/>
			</li>
			<li>
				<input type="text" placeholder="邮件验证码"/>
				<span class="code-btn colorblue">获取验证码</span>
			</li>
			<li>
				<input type="password" placeholder="账号"/>
			</li>
			<li>
				<input type="password" placeholder="密码"/>
			</li>
			<li>
				<input type="password" placeholder="确认密码"/>
			</li>
		</ul>
		<span class="login-btn">注册</span>
    </div>
  </div>
</template>

<script>
import HeaderSub from '../../components/HeaderSub'
export default {
  name: '',
  components: {
    HeaderSub
  }
}
</script>

<style scoped>
.register-tips{position:relative; top: -15px; text-align: center;}
.register-tips a{color:#007DFF}
</style>
